import React, { useState, useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import {
  signInWithEmailAndPassword,
  setPersistence,
  browserLocalPersistence
} from 'firebase/auth';
import { auth } from './firebase';

const Login = () => {
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [error, setError] = useState('');
  const [infoMessage, setInfoMessage] = useState('');
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('revoked') === '1') {
      setInfoMessage(
        'Your parent portal access is no longer active. If you believe this is a mistake, contact the team administrator.'
      );
    } else if (searchParams.get('setup') === '1') {
      setInfoMessage(
        'We could not find a complete parent account record. Please contact the team administrator for help.'
      );
    } else {
      setInfoMessage('');
    }
  }, [searchParams]);

  const handleLogin = async (e) => {
    e.preventDefault();

    try {
      setInfoMessage('');
      await setPersistence(auth, browserLocalPersistence);
      await signInWithEmailAndPassword(auth, email, password);
      navigate('/parents-only', { replace: true });
    } catch (err) {
      setError('Incorrect email or password');
      console.error(err);
    }
  };

  return (
    <div className="login-page">
      <h1>Parent Login</h1>
      <form onSubmit={handleLogin} style={{ maxWidth: '400px', margin: '0 auto' }}>
        <div className="form-group">
          <label>Email</label>
          <input
            type="email"
            className="form-control"
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
            placeholder="Enter your email"
          />
        </div>

        <div className="form-group mt-3">
          <label>Password</label>
          <input
            type="password"
            className="form-control"
            value={password}
            onChange={(e) => setPassword(e.target.value)}
            required
            placeholder="Enter your password"
          />
        </div>

        {infoMessage && (
          <p style={{ color: '#B4975A', marginTop: '10px', lineHeight: 1.5 }} role="status">
            {infoMessage}
          </p>
        )}
        {error && <p style={{ color: 'red', marginTop: '10px' }}>{error}</p>}

        <button type="submit" className="btn btn-teal mt-4">Log In</button>

        <p style={{ marginTop: '20px' }}>
          Don’t have an account? <a href="/signup">Sign up here</a>
        </p>

        <p>
          Forgot your password? <a href="/reset-password">Reset it here</a>
        </p>
      </form>
    </div>
  );
};

export default Login;
